import React from 'react';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { detectTextDirection } from '../../../../../../Utils/textDirection';
import { formatFullTime } from '../../../../utils/messageRenderUtils';
import MessageInfoSection from '../MessageInfoSection/MessageInfoSection';
import { getMessageDetailsThemeColors } from '../MessageDetails.helpers';

const { Text } = Typography;

const MessageReplyContext = ({ replyToMessage, isDarkMode }) => {
    const { t } = useTranslation();
    const themeColors = getMessageDetailsThemeColors(isDarkMode);

    if (!replyToMessage) return null;

    return (
        <MessageInfoSection title={t('replying_to')}>
            <Space direction="vertical">
                <Text
                    dir={detectTextDirection(replyToMessage.content)}
                    style={{ color: themeColors.text, whiteSpace: 'pre-wrap', unicodeBidi: 'plaintext' }}
                >
                    {replyToMessage.content}
                </Text>
                <Text type="secondary" style={{ color: themeColors.secondaryText }}>
                    {t('by')} {replyToMessage.sender_type} {t('at')} {formatFullTime(replyToMessage.status?.sent_at)}
                </Text>
            </Space>
        </MessageInfoSection>
    );
};

export default MessageReplyContext;
